import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, {} from 'react';
export function Input({ label, error, helperText, className, disabled, id, ref, inputMode, autoFocus, ...props }) {
    const showMessage = error || helperText;
    const message = error || helperText || '';
    const classNames = [
        'w-full rounded-md border px-3 py-2 text-sm shadow-sm transition-all focus:outline-none',
        'placeholder:text-gray-400',
        'h-[40px]', // consistent input height
        className,
    ];
    if (disabled) {
        classNames.push('bg-gray-100 cursor-not-allowed border-gray-200 text-gray-500');
    }
    else if (error) {
        classNames.push('border-red-500 focus:ring-1 focus:ring-red-500 focus:border-red-500');
    }
    else {
        classNames.push('border-gray-300 focus:ring-1 focus:ring-tym-green/90 focus:border-tym-green/90');
    }
    let ariaDescribedBy;
    if (error) {
        ariaDescribedBy = `${id}-error`;
    }
    else if (helperText) {
        ariaDescribedBy = `${id}-helper`;
    }
    return (_jsxs("div", { className: "w-full", children: [label && (_jsx("label", { htmlFor: id, className: [
                    'mb-1 block text-sm font-medium',
                    disabled ? 'text-gray-400' : 'text-gray-700',
                ].join(' '), children: label })), _jsx("input", { id: id, ref: ref, className: classNames.join(' '), disabled: disabled, inputMode: inputMode, autoFocus: autoFocus, "aria-invalid": !!error, "aria-describedby": ariaDescribedBy, ...props }), _jsx("div", { className: "min-h-[18px] mt-1", children: showMessage && (_jsx("p", { id: error ? `${id}-error` : `${id}-helper`, className: [
                        'text-xs',
                        error ? 'text-red-500' : 'text-gray-500',
                    ].join(' '), children: message })) })] }));
}
//# sourceMappingURL=Input.js.map